<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">

        <!-- <layout-header /> -->

        <!-- Page Content -->
        <div class="content">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-6 col-12">
                        <div class="card success-card">
                            <div class="card-body">
                                <div class="mt-2 mb-4 text-center">
                                    <img src="@/assets/img/logo.png" alt="6v6" title="6v6 Logo"
                                        class="d-inline-block w-auto mx-auto" style="height: 2rem;">
                                </div>
                                <div v-if="booking !== null && booking.status === 'pending approval'" class="p-2">
                                    <div class="d-flex justify-content-start align-items-center mb-3">
                                        <img :src="establishment?.logo_url || defaultLogo" class="mr-3 rounded-lg" width="70px" height="70px" alt="Company Logo">
                                        <div>
                                            <h4>Terrain {{ facility?.name }}</h4>
                                            <h5 class="text-muted font-weigh-bolder">{{ establishment?.business_name }}</h5>
                                        </div>
                                    </div>
                                    
                                    <div class="booking-summary">
                                        <div class="booking-item-wrap">
                                            <ul class="booking-date">
                                                <li style="margin-bottom: 4px;">
                                                    Réservé par <span>{{ booking?.user_name }}</span>
                                                </li>
                                                <li style="margin-bottom: 4px;">
                                                    Date <span>{{ formatDateTime(booking?.start_time).date }}</span>
                                                </li>
                                                <li style="margin-bottom: 4px;">
                                                    Créneau
                                                    <span>
                                                        {{ formatDateTime(booking?.start_time, 'HH:mm').time }} -
                                                        {{ formatDateTime(booking?.end_time, 'HH:mm').time }}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="submit-section d-flex justify-content-center align-items-center pt-5">
                                        <button class="btn btn-rounded btn-submit btn-success px-3 mx-2 text-sm" @click="approveBooking('confirm')">
                                            Confirmer
                                        </button>
                                        <button class="btn btn-rounded btn-submit btn-danger px-3 mx-2 text-sm" @click="approveBooking('reject')">
                                            Rejeter
                                        </button>
                                    </div>
                                </div>
                                <div v-else class="pt-5 text-sm text-center">
                                    Résérvation introuvable.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Page Content -->

        <!-- Footer -->
        <!-- <layout-footer /> -->
        <!-- /Footer -->

    </div>
</template>
<style scoped>
body {
    background-color: #d0d0d0 !important;
}
</style>
<script>
import { api } from '@/store';
import defaultLogoPath from '@/assets/img/photo.png'

export default {
    props: ['id'],
    data() {
        return {
            defaultLogo: defaultLogoPath,
            booking: null,
            facility: null,
            establishment: null
        }
    },
    mounted() {
        $('body').addClass('bg-light')
        this.getBooking()
    },
    methods: {
        getBooking() {
            return api.get('/booking-approval/' + this.id)
                .then(response => {
                    this.booking = response.data
                    this.facility = this.booking.slot.facility
                    this.establishment = this.facility.establishment
                })
                .catch(error => {
                    // this.errorMessage = error.response.data.detail
                })
        },
        approveBooking(decision) {
            const label = (decision === 'confirm') ? 'confirmer' : 'rejeter'
            this.$store.dispatch('modal/triggerModal', {
                stacked: true,
                icon: 'warning',
                icon_color: 'text-warning',
                title: 'Attention!',
                detail: `Voulez-vous ${label} cette réservation?`,
                prompt: true,
                onResult: (confirmed) => {
                    if (confirmed) {
                        $('.btn-submit').attr('disabled', 'disabled')
                        api.post(`/booking-approval/${this.id}/${decision}`, {})
                            .then(response => {
                                    this.$store.dispatch('modal/triggerModal', {
                                        stacked: true,
                                        icon: 'check_circle',
                                        icon_color: 'text-success',
                                        title: 'Succès',
                                        detail: 'Votre décision a été prise en compte',
                                    })
                                    setTimeout(() => {
                                        this.$router.push('/')
                                    }, 3000)
                                })
                            .catch(error => {
                                    this.$store.dispatch('modal/triggerModal', {
                                        stacked: true,
                                        icon: 'error',
                                        icon_color: 'text-danger',
                                        title: 'Erreur',
                                        detail: error.response?.data?.message || 'Une erreur est survenue! Veuillez réessayer plus tard.',
                                    })
                                })
                    }
                }
            })
        },
        formatDateTime(datetimeString) {
            if (!datetimeString) return "";
            const date = new Date(datetimeString);
            const formattedDate = date.toISOString().split("T")[0];
            let displayDate = date.toLocaleDateString("fr-FR", { weekday: "short", year: "numeric", month: "short", day: "numeric" }).split("T")[0];
            displayDate = displayDate.split(" ") .map(word => word.charAt(0).toUpperCase() + word.slice(1)) .join(" ");
            // Extract local hours and minutes
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            let date_obj = {
                date: displayDate,
                time: `${hours}:${minutes}`,
                datetime: formattedDate + ` ${hours}:${minutes}`,
            };
            return date_obj;
        },
    }
}
</script>